<template>

    <DashboardContainer
            :style="'px-0 mx-0'"
            @refresh="loadConfigs"
            :refresh-button="true"
    >

        <DashboardCard
                header-title="SMS Configs"
                column="w-100"
        >

            <div class="d-block position-relative p-0 m-0">

                <div
                        class="row p-3"
                        :class="index%2!==0 ? 'bg-white' : 'bg-light'"
                        v-for="(singleConfig, index) in configs"
                        :key="index"
                >

                    <div class="col-12 p-2 fw-bolder">

                        <h4 class="fw-bolder">
                            Institution ID :
                            {{ singleConfig.institutionId }}
                        </h4>

                    </div>


                    <div class="col-12 p-2">

                        <strong>Sender ID :</strong>
                        {{ singleConfig.senderId }}

                    </div>


                    <div class="col-12 p-2">

                        <strong>PE ID :</strong>
                        {{ singleConfig.peId }}

                    </div>


                    <div class="col-12 p-2">

                        <strong>DCS :</strong>
                        {{ singleConfig.dcs }}

                    </div>


                    <div class="col-12 p-2">

                        <strong>Flash SMS :</strong>
                        {{ singleConfig.flashSms }}

                    </div>


                    <div class="col-12 p-2">

                        <strong>Token :</strong>

                        {{
                            singleConfig.token
                                ? singleConfig.token.substring(0, 10) + "********"
                                : ""
                        }}

                    </div>


                    <div class="col-12 p-2">

                        <strong>Status :</strong>

                        <span
                                :class="singleConfig.active
                                ? 'text-success'
                                : 'text-danger'"
                        >
                            {{
                                singleConfig.active
                                ? 'ACTIVE'
                                : 'INACTIVE'
                            }}
                        </span>

                    </div>


                    <div class="col-md-6">

                        <Button
                                label="Update"
                                icon="pi pi-pencil"
                                severity="warn"
                                size="small"
                                outlined
                                class="w-100"
                                @click="updateConfig(singleConfig)"
                        />

                    </div>


                    <div class="col-md-6">

                        <Button
                                label="Delete"
                                icon="pi pi-trash"
                                severity="danger"
                                size="small"
                                outlined
                                class="w-100"
                                @click="deleteConfig(singleConfig, index)"
                        />

                    </div>

                </div>


                <div
                        class="d-block position-relative"
                        v-if="configs.length===0"
                >

                    <h3 class="my-0 text-danger text-center">
                        No SMS Configs Found
                    </h3>

                </div>

            </div>

        </DashboardCard>

    </DashboardContainer>

</template>

<script>

import DashboardContainer from "@/dashboard/containers/DashboardContainer.vue";
import DashboardCard from "@/dashboard/containers/DashboardCard.vue";

import Button from "primevue/button";

export default {

    name: "ListSmsConfigs",

    components : {
        DashboardContainer,
        DashboardCard,
        Button
    },

    emits : [
        "update"
    ],

    data(){
        return{
            configs : []
        }
    },

    methods : {

        loadConfigs(){

            this.$api.get("/sms-config/list")
                .then(response => {

                    this.configs = response.objects;

                }).catch(error => {

                    this.$root['handleApiError'](
                        error,
                        "SMS Config Loading"
                    );

                });

        },

        updateConfig(config){

            this.$emit(
                "update",
                config
            );

        },

        deleteConfig(config, index){

            this.$api.delete(
                "/sms-config/delete/" + config.id
            ).then(response => {

                this.configs.splice(index, 1);

                this.$root['showAlert'](
                    "success",
                    "Deletion",
                    response.message
                );

            }).catch(error => {

                this.$root['handleApiError'](
                    error,
                    "Deletion"
                );

            });

        }

    },

    beforeMount() {

        this.loadConfigs();

    }

}
</script>

<style scoped lang="scss">

</style>